export default __webpack_public_path__ + "4648876ec867ce07fe6f429312c8fd0c.svg";